import { makeStyles } from '@material-ui/core';

const useRadioGroupStyles = makeStyles({
    radioGroupRow: {
        width: '30%',
        height: 'auto',
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        whiteSpace: 'nowrap',
    },
    radioGroupColumn: {
        width: 'auto',
        height: 'auto',
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column',
        '& .MuiFormControlLabel-root' : {
            marginRight: '0px',
            marginLeft: '0px'
        },
        '& .MuiFormControlLabel-root:not(:last-child)': {
            borderBottom: '1px solid #E0E0E0'
        }
    }
});

export default useRadioGroupStyles;